module.exports = __webpack_public_path__ + "img/jackpot-bg_768.dff4f41e.png";